module.exports = __webpack_public_path__ + "static/img/02.64ddfe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/huegler/02.jpg
// module id = 376
// module chunks = 1